export default __webpack_public_path__ + "static/media/anniversary_En.6a779f1a.jpg";